/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {BASE_CLASS, DEFAULT_EMPTY_MULTIPLE_VALUE, DEFAULT_EMPTY_OPTIONS, NO_OP} from '../../config.js'
import FilterBasicLegacyMultiSelectionItem from './Item/index.js'
import {ALL_OPTIONS_ID, DESIGNS} from './config.js'

const FilterBasicLegacyMultiSelection = ({
  allSelectionsLabel,
  defaultAreAllOptionsChecked = false,
  design = DESIGNS.NORMAL,
  onChange = NO_OP,
  options = DEFAULT_EMPTY_OPTIONS,
  values = DEFAULT_EMPTY_MULTIPLE_VALUE
}) => {
  const [allOptionsChecked, setAllOptionsChecked] = useState(defaultAreAllOptionsChecked)

  useEffect(() => {
    setAllOptionsChecked(defaultAreAllOptionsChecked)
  }, [defaultAreAllOptionsChecked])

  const baseClass = cx(BASE_CLASS, `${BASE_CLASS}-list`)

  const filterBasicLegacyMultiSelectionItemWrapper = cx(
    `${BASE_CLASS}-multiSelectionItemWrapper`,
    `${BASE_CLASS}-multiSelectionItemWrapper--${design}`
  )

  const hasAllSelectionsItem = Boolean(allSelectionsLabel)

  const areAllOptionsChecked =
    allOptionsChecked ||
    (options.length && options.every(({id: optionId}) => values.find(id => String(optionId) === String(id))))

  const handleSelectItem = ({id}) => {
    if (hasAllSelectionsItem) {
      if (id === ALL_OPTIONS_ID) {
        setAllOptionsChecked(!allOptionsChecked)

        const allOptionsIds = options.map(({id}) => id)

        const newOptions = areAllOptionsChecked ? [] : allOptionsIds

        return onChange(newOptions)
      }
      setAllOptionsChecked(false)

      if (hasAllSelectionsItem && areAllOptionsChecked) {
        return onChange([id])
      }
    }

    const isPreviouslySelected = values.includes(id)

    return isPreviouslySelected ? removeCurrentSelectedItem({id}) : setNewSelections({id})
  }

  const setNewSelections = ({id}) => {
    const newSelections = [...values, id]
    onChange(newSelections)
  }

  const removeCurrentSelectedItem = ({id}) => {
    const cleanedCurrentSelections = values.filter(currentSelection => String(currentSelection) !== String(id))
    onChange(cleanedCurrentSelections)
  }

  return (
    <ul className={baseClass}>
      {hasAllSelectionsItem && (
        <li className={filterBasicLegacyMultiSelectionItemWrapper}>
          <FilterBasicLegacyMultiSelectionItem
            id={ALL_OPTIONS_ID}
            isSelected={areAllOptionsChecked}
            label={allSelectionsLabel}
            onChange={handleSelectItem}
          />
        </li>
      )}
      {options.map(({extendedInfo, icon, id, isHighlighted, label}) => {
        const isSelected = hasAllSelectionsItem ? !areAllOptionsChecked && values.includes(id) : values.includes(id)

        return (
          <li className={filterBasicLegacyMultiSelectionItemWrapper} key={id}>
            <FilterBasicLegacyMultiSelectionItem
              extendedInfo={extendedInfo}
              icon={icon}
              id={id}
              isHighlighted={isHighlighted}
              isSelected={isSelected}
              key={id}
              label={label}
              onChange={handleSelectItem}
            />
          </li>
        )
      })}
    </ul>
  )
}

FilterBasicLegacyMultiSelection.displayName = 'FilterBasicLegacyMultiSelection'
FilterBasicLegacyMultiSelection.propTypes = {
  allSelectionsLabel: PropTypes.string,
  defaultAreAllOptionsChecked: PropTypes.bool,
  design: PropTypes.oneOf(Object.values(DESIGNS)),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      extendedInfo: PropTypes.string,
      icon: PropTypes.func,
      id: PropTypes.string.isRequired,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string.isRequired
    })
  ),
  values: PropTypes.array
}

export {FilterBasicLegacyMultiSelectionItem, DESIGNS as filterBasicLegacyMultiSelectionDesigns}
export default FilterBasicLegacyMultiSelection
